import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Chip,
  Paper,
  FormControlLabel,
  IconButton,
  Avatar,
  Tooltip,
} from "@material-ui/core";
import {
  CircularProgress,
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  FormControl,
  Switch,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,Input
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  CheckCircle,
  Block,
  Delete,
  Edit,
  AccountCircle,
  Close,
  PermIdentity,
  ArrowForwardIos,
  SubdirectoryArrowLeftOutlined,
  AccountBalance,
  Schedule,
  Money,
  VpnLock,
  CreditCard,
  RotateLeft
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";
import { useRoles, useOrgRoles } from "../../../hooks/use_hooks";

import MUIDataTable from "mui-datatables";
import MaskedInput from "react-text-mask";

import { makeStyles } from "@material-ui/styles";
import {
  FinanceService,
  AdminService,
  ReportingService,
  Validator,
  Permissions,
} from "../../../../../utils/web_config";
import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function MaskedNID(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        " ",
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask={false}
      keepCharPositions={true}
    />
  );
}


function MemberAgent(props) {
  const classes = useStyles();
  const history = useHistory();

  const ad = localStorage.getItem("nx_cent");
  const roles = useOrgRoles({
    org_id: JSON.parse(ad)?.organization.organization_id,
  });

  const [accountData, setAccountData] = useState({});

  const [addNewOpen, setAddNewOpen] = useState(false);

  const [agents, setAgents] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    toggling: false,
    data: [],
  });

  const [selectedAgent, setSelectedAgent] = useState({
    saving: false,
    loading: false,
    data: {},
  });

  const [agentAccount, setAgentAccount] = useState({
    saving: false,
    loading: false,
    data: {},
  });

  const [agentEditMode, setAgentEditMode] = useState({
    status: false,
    suspend: false,
  });

  const [hasCode, setHasCode] = useState({
    open: false,
    loading: false,
  });



  const [id, setId] = useState({ value: "", error: "" });
  const [idData, setIdData] = useState({
    loading: false,
    saving: false,
    open: false,
  });

  const [status, setStatus] = useState("Loading individual agents....");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();





  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getAgents(accountData.token);
  }, []);



  /////////////

  const clearUserInfo = () => {
    setCard({ value: "", error: "" });
  };
  /////////////
  const toggleUser = (id) => {
    const assInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    const user = agents.data.filter((obj) => obj.user_id == id)[0];
    const i = agents.data.indexOf(user);

    var url =
      user.status == "ENABLED"
        ? new AdminService().DEACTIVATE_USER + id
        : new AdminService().REACTIVATE_USER + id;

    user["status"] =
      user.status == "ENABLED" ? "DISABLED" : "ENABLED";

    console.log("togglinguser.....");

    setAgents({ ...agents, toggling: true });

    assInstance
      .put(url)
      .then(function (response) {
        const d = response.data;

        user["status"] = user.user_status;

        const usrs = agents.data;
        usrs[i] = user;
        setAgents({ ...agents, data: usrs, toggling: false });

        notify("success", d.data);
      })
      .catch(function (error) {
        user["user_status"] =
          user.user_status == "ENABLED" ? "DISABLED" : "ENABLED";

        user["status2"] = user.user_status;

        const usrs = agents.data;
        agents[i] = user;
        setAgents({ ...agents, data: usrs, toggling: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  ////////////////////////////////
  //////////////
  const [card,setCard] =useState({ value:'',error:''});
  const [code,setCode] = useState({ value: '',error:''});
  const showAgentEdit = (id) => {
    setAddNewOpen(true);
    setAgentEditMode({ ...agentEditMode, status: true, id: id });
    const agent = agents.data.filter((obj) => obj.id == id)[0];
    setCard({ value: agent.card, error: ''});
    setCode({ value: agent.code, error: ''});
  };

  const updateAgent = () => {
    const updateInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );
    var data = {
      agent_code: code.value,
      card_number: card.value
    }

    setAgents({ ...agents, saving: true });

    console.log("Updating agent.....");

    updateInstance
      .post(new FinanceService().ASSIGN_CARD, data)
      .then(function (response) {
        setAgents({ ...agents, saving: false });
    
        getAgents(accountData.token);
        clearUserInfo();
        notify("success", response.data.message);

        setAgentEditMode({ status: false });
        setAddNewOpen(false);
      })
      .catch(function (error) {
        setAgents({ ...agents, saving: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        console.log(error);

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };
  ////////////////////////////////

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "name",
      label: "Member Name",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "code",
      label: "Code",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "phone_number",
      label: "Phone Number",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "serial_number",
      label: "Card",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {agents.data[dataI].status.toLowerCase() == "enabled" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                agents.data[dataI].status.toLowerCase() == "enabled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(agents.data[dataI]?.status)}
            />
          );
        },
      },
    },
  ];


  const options = {
    filterType: "multiselect",
    elevation: 0,
    selectableRows: "single",
    searchPlaceholder: "Search agent...",
    selectableRowsOnClick: false,
    fixedHeader: true,
    // onCellClick: (cellData, cellMeta) => {
    //   var user = agents?.data[cellMeta.dataIndex];
    //   user['agent_code']=user.code

    
    //   if (user.agent_code == null) {
    //     setHasCode({...hasCode, id: user.id,open:true });
      
    //     return;
    //   }else if(user==null){
    //     return
    //   }
    //   history.push("/centrika/agents/indiv", user);
    // },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: status,
      },
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomUsersToolbar
        selectedRows={selectedRows}
        displayData={displayData}
        setSelectedRows={setSelectedRows}
        toggleUser={toggleUser}
        openEdit={showAgentEdit}
        toggling={agents.toggling}
      />
    ),
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };
  const getAgents = (token, id) => {
    const agentsInstance = axios.create(new AdminService().getHeaders(token));

    setAgents({ ...agents, loading: true });

    console.log("getting agents .....");

    agentsInstance
      .get(new FinanceService().GET_AGENTS_CARD +'?page=0&per_page=10000&agent_type_code=AGT-MBAG')
      .then(function (response) {
        setAgents({ ...agents, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setStatus("There are no agents available.");
        } else {
          setAgents({
            ...agents,
            data: d.data,
          });
        }
      })
      .catch(function (error) {
        setAgents({ ...agents, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setStatus(e);

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  
  const [filterDialog, setPaymentDialog]=useState(false);  
  const [username, setUsername]=useState({value:'',error:''});
  const [paymentLoad,setPaymentLoad] = useState(false);
  const initiateServiceFeePayment = () => {
    const agentsInstance = axios.create(new AdminService().getHeaders(accountData.token));
    if(username.value===''){
      setUsername({value:'',error:'Invalid username'})
    }else{
      setPaymentLoad(true);
      const data = {
        username: username.value.toUpperCase(),
      }
      agentsInstance
        .post(new FinanceService().INITIATE_SERVICE_FEE_PAYMENT, data)
        .then(function (response) {
          setPaymentLoad(false);
          setPaymentDialog(false);
          notify("success", "Service Fee Payment initiated successfully!");
        })
        .catch(function (error) {
          setPaymentLoad(false);
          var e = error.message;

          if (error.response) {
            e = error.response.data.message;
          }
          setStatus(e);

          notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
        });
    }
  };


  ///////////////////////////////////



  return (
    <div className={classes.root}>
      {/* Dialogs starts here */}

          {/* //////////////////////// */}



      <Dialog
        open={addNewOpen}
        maxWidth="sm"
        fullWidth
        onClose={() => setAddNewOpen(false)}
      >
        <DialogTitle id="new-op">
          Assign/Change Card
        </DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <Translate>
              {({ translate }) => (
                <TextField
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={card.value}
                  placeholder={"Card Number"}
                  label={"Card Number"}
                  fullWidth
                  onChange={(e)=>{
                    if(e.target.value === ""){
                      setCard({ value: '', error: 'Invalid Card Number' });
                    }else{
                      setCard({ value: e.target.value, error: '' });
                    }
                  }}
                  helperText={card.error}
                  error={card.error !== ""}
                />
              )}
            </Translate>
          </Box>

    
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              clearUserInfo();
              setAddNewOpen(false);
              setAgentEditMode({ ...agentEditMode, status: false });
            }}
            variant="outlined"
            color="primary"
          >
            <Translate id="agents.forms.buttons.cancel" />
          </Button>
          <Button
            disabled={agents.saving}
            variant="contained"
            color="primary"
            onClick={updateAgent}
            disableElevation
          >
            {agents.saving ? (
              <CircularProgress size={23} />
            ) : agentEditMode.status ? (
              "Save"
            ) : (
              <Translate id="users.forms.buttons.register" />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialogs ends here */}

      <Box display="flex">
        <Box mr={2}>
          {" "}
          <PermIdentity color="primary" fontSize="large" />
        </Box>
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h5">
            <b>Agents</b>
          </Typography>
          <Box ml={1} mr={1} mt={1}>
            <ArrowForwardIos fontSize="small" />
          </Box>
          <Typography variant="h6">Cooperative Member</Typography>
        </Box>
        <Button
          className={classes.btn}
          color="primary"
          variant="contained"
          size="medium"
          disabled={paymentLoad}
          startIcon={<RotateLeft />}
          disableElevation
          onClick={() => {
            setPaymentDialog(true);
            // initiateServiceFeePayment();

          }}
        >
          {paymentLoad ? "Loading" :"Initiate Service Fee Payment"}
        </Button>
      </Box>
      <Box mt={3} />

      {agents.loading && <LinearProgress />}
      <MUIDataTable
        title={"List of Member Agents"}
        data={agents.data}
        columns={columns}
        options={options}
      />
      
      {/* start dialog  */}
      <Dialog
        maxWidth='sm'
        fullWidth
        open={filterDialog}
        onClose={() => {
          setPaymentDialog(false);
        }}
        aria-labelledby='filter'
        aria-describedby='filter'
      >
        <DialogTitle id='filter'>{'Initiate Payment'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Box mt={2}>
                <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={username.value}
                  placeholder={"Username"}
                  label={"Username"}
                  fullWidth
                  helperText={username.error}
                  error={username.error !== ""}
                  onChange={(e) => {
                    setUsername({ value: e.target.value, error: '' });
                  }}
                />
              </Box>

            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setPaymentDialog(false);
            }}
            color='secondary'
            className={classes.btn}
          >
            <Typography>Close</Typography>
          </Button>

          <Button
            onClick={() => {
              initiateServiceFeePayment();
            }}
            color='primary'
            variant='contained'
            className={classes.btn}
            disableElevation>
            {paymentLoad ? (
              <CircularProgress size={25} color='secondary' />
            ) : (
              <Typography>Initiate Payment</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
      {/* end dialog */}

    </div>
  );
}

function CustomUsersToolbar(props) {
  const { toggleUser, displayData, selectedRows, openEdit } = props;

  var check = displayData[selectedRows?.data[0]?.index].data[6] == "ENABLED";

  return (
    <Box display="flex" alignItems="center">

      <Button
        color="primary"
        variant="outlined"
        size="small"
        startIcon={<CreditCard />}
        onClick={() =>
          openEdit(displayData[selectedRows?.data[0]?.index]?.data[0])
        }
      >
        Assign Card
      </Button>

    </Box>
  );
}

export default withLocalize(MemberAgent);
